import { ReactNode } from 'react';
import cx from 'classnames';

import { useSuiteApp } from '_common/suite/SuiteContext/SuiteContext';
import { Divider, Toggle } from '@ets/design-system';
import { useDispatch } from '_common/hooks';
import { setSidebarView } from 'Editor/redux/SidebarSlice';

import styles from './PanelHeading.module.scss';

type PanelHeadingProps = {
  editor?: boolean;
  children: ReactNode;
  //Reference: OnboardingEditor>Standalone, used to get dynamic position of element
  id?: string;
};

const PanelHeading = ({ children, id }: PanelHeadingProps) => {
  const suiteApp = useSuiteApp();
  const dispatch = useDispatch();
  return (
    <>
      <div id={id} className={cx(styles.panelheading)}>
        {children}
        {suiteApp === 'document' && (
          <Toggle
            iconProps={{ icon: 'xmark' }}
            size="m"
            variant="link"
            testId="close"
            onClick={() => dispatch(setSidebarView(null))}
          />
        )}
      </div>
      <Divider margin="0" />
    </>
  );
};

export default PanelHeading;
